var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getLoaderState)?_c('div',{staticClass:"loader"},[_vm._v(" "+_vm._s(_vm.$t("main.loading"))+" "),_c('img',{attrs:{"src":"/images/loader.svg","alt":"loading"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }